import { render } from "./LabelInput.vue?vue&type=template&id=e02a127c&scoped=true&ts=true"
import script from "./LabelInput.vue?vue&type=script&lang=ts"
export * from "./LabelInput.vue?vue&type=script&lang=ts"

import "./LabelInput.vue?vue&type=style&index=0&id=e02a127c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e02a127c"]])

export default __exports__